module.exports = __webpack_public_path__ + "static/media/bg-main-visual.20c7b249.mp4";